// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2-50q","infoBtn":"quickbooks_infoBtn__2Ceyc","formBox":"quickbooks_formBox__qt8Zc","formFooter":"quickbooks_formFooter__3iDIF"};